<template>
  <div class="slide-image-captcha" v-if="show">
    <div class="mask"></div>
    <captcha
      ref="dialogopen"
      :l="42"
      :r="10"
      :w="catcha.w"
      :h="catcha.h"
      :blocky="catcha.blocky"
      :imgurl="catcha.imgurl"
      :miniimgurl="catcha.miniimgurl"
      :slider-text="catcha.text"
      @success="onSuccess"
      @fail="onFail"
      @refresh="onRefresh"
      @close="onClose"
    ></captcha>
  </div>
</template>

<script>
  import captcha from "./captcha";
  import { V4_URL } from "../../config/api";
  import { post_v2, fetch_v2 } from "../../config/http";

  export default {
    components: {
      captcha
    },
    name: "slideImageCaptcha",
    data () {
      return {
        show: false,
        catcha: {
          blocky: 0,
          imgurl: '',
          miniimgurl: '',
          text: '拖动左边滑块完成上方拼图',
          h: 160,
          w: 260,
          sh: 50,
          sw: 40,
          modifyImg: ''
        }, // 图片验证码传值
        codeId: ''
      }
    },
    methods: {
      onSuccess(left,hdd,trail) {
        const that = this
        const trails = []
        trail.forEach(item => {
          trails.push({
            x: item[0],
            y: item[1]
          })
        })
        post_v2(V4_URL.checkSlideCode, { codeId: that.codeId, x: trail[trail.length - 1][0], y: trail[trail.length - 1][1], trails }, false, true).then(res => {
          this.$refs.dialogopen.handleSuccess()
          that.$emit('success', res.codeId, res.codeToken)
          setTimeout(() => {
            that.show = false
          },500)
        }).catch(err => {
          this.$refs.dialogopen.handleFail()
          setTimeout(() => {
            that.onRefresh()
          },500)
        })
      },
      onFail () {

      },
      onRefresh () {
        const that = this
        that.$refs.dialogopen.reset()
        that.getCaptcha()
      },
      onClose () {
        this.show = false
        this.$emit('close')
      },
      showCaptcha () {
        const that = this
        that.show = true
        that.getCaptcha()
      },
      getCaptcha () {
        const that = this
        return new Promise(function (resolve, reject) {
          fetch_v2(V4_URL.getSlideCode, {}).then(res => {
            var imgobj = res
            that.catcha.blocky = imgobj.y
            that.catcha.imgurl = imgobj.image
            that.catcha.miniimgurl = imgobj.smallImage
            that.codeId = imgobj.codeId
            that.$nextTick(function () {
              that.$refs.dialogopen.init()
              resolve()
            })
          }).catch(err => {
            console.log(err)
            reject()
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.slide-image-captcha{
  .mask{
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    padding: 0;
    z-index: 999998;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/captcha2/slideImageCaptcha.vue